import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent implements OnInit {
  contacts = [
    {
      phones: ['+55 (11) 3145-3200'],
      address: {
        location: 'settings.contact-and-help.address.sao-paulo.location',
        address: 'settings.contact-and-help.address.sao-paulo.address'
      }
    },
    {
      phones: ['+55 (47) 3075-0601', '+55 (47) 3075-0248'],
      address: {
        location: 'settings.contact-and-help.address.itajai.location',
        address: 'settings.contact-and-help.address.itajai.address'
      }
    }
  ];

  brasilia = {
    phones: ['+55 (61) 3246-2713', '+55 (61) 3246-2714']
  };
  constructor() {}

  ngOnInit(): void {}
}
